module.exports = __webpack_public_path__ + "img/coupon_zhCn.55fe2f29.png";